import classNames from "classnames"
import { RefObject } from "react"
import { Modal, ProfilePic } from "@collegebacker/backer-ui/ui"

import styles from './GreetingModal.module.scss'

const GreetingModal = ({
  modalRef,
  photoUrl,
  name,
  greeting
}: Props) => {
  return (
    <Modal
      isBottomSheet={true}
      ref={modalRef}
      contentClassName={classNames(
        'typo-app-body-large-paragraph',
        styles.greetingModal
      )}
    >
      <div
        className={styles.ownerPhotoContainer}
      >
        <ProfilePic
          imageSrc={photoUrl}
          name={name}
          className={styles.photoSmall}
        />
        <p className='typo-app-body-caption'>{name}</p>
      </div>
      {greeting}
    </Modal>
  )
}

interface Props {
  modalRef: RefObject<HTMLDialogElement>
  photoUrl: string
  name: string
  greeting: string
}

export default GreetingModal